import styled, { keyframes } from 'styled-components'

const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}` : null
}

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  cursor: ${p => p.disabled ? 'default' : 'pointer'};

  &:hover {
    background-color: ${p => p.disabled ? 'inherit' : hexToRgb(p.theme.colors.primary) ? `rgba(${hexToRgb(p.theme.colors.primary)}, 0.1)` : 'rgba(0, 0, 0, 0.1)'};
  }
`

export const Box = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: ${p => p.disabled && p.checked ? '#888' : p.checked ? p.theme.colors.primary : '#fff'};
  border: 2px solid ${p => p.disabled ? '#888' : p.theme.colors.primary};
  border-radius: 3px;
  z-index: 1;
`

export const Check = styled.em`
  color: #fff;
`

const clickEffect = keyframes`
  0% {
    width: 20px;
    height: 20px;
    opacity: 0;
    box-shadow: 0 0 5px inset rgba(0, 0, 0, 0);
  }
  40% {
    width: 100%;
    height: 100%;
    opacity: 0.2;
    box-shadow: 0 0 15px inset rgba(0, 0, 0, 0.2);
  }
  100% {
    width: 100%;
    height: 100%;
    opacity: 0;
    box-shadow: 0 0 15px inset rgba(0, 0, 0, 0);
  }
`

export const Shadow = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${p => p.theme.colors.primary};
  border-radius: 50%;
  opacity: 0;

  &.animate {
    animation: ${clickEffect} .4s linear;
  }
`

export const Input = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:focus {
    outline: none;
  }
`

export const Label = styled.label`
  padding-left: 5px;
  margin-bottom: 0;
  color: ${p => p.disabled ? '#888' : 'inherit'};
  cursor: ${p => p.disabled ? 'default' : 'pointer'};
`